module.exports = __webpack_public_path__ + "static/media/no_cat-grey.b278abe8.png";